import { phoneCodes } from "./CountryCodes";
export function loadJs(file) {
    const script = document.createElement("script");
    script.type = "application/javascript";
    script.src = file;
    document.body.appendChild(script);
}
export function wrapImgWithLighbox(image) {
    const link = document.createElement('a');
    link.dataset.fslightbox = 'products-gallery';
    link.dataset.caption = image.alt;
    link.href = image.src;
    image.parentNode?.replaceChild(link, image);
    link.appendChild(image);
}
export function wrapPictureWithLighbox(picture) {
    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    const image = picture.querySelector('img');
    const link = document.createElement('a');
    link.dataset.fslightbox = 'products-gallery';
    link.dataset.caption = image.alt;
    link.href = image.src;
    picture.parentNode?.replaceChild(link, picture);
    link.appendChild(picture);
}
export function copyTextToClipboard(text) {
    navigator.clipboard.writeText(text);
}
export function isMobile() {
    const MOBILE_RESOLUTION = 992;
    return window.innerWidth <= MOBILE_RESOLUTION;
}
export function arrayMinMax(arr) {
    return arr.reduce(([min, max], val) => [Math.min(min, val), Math.max(max, val)], [
        Number.POSITIVE_INFINITY,
        Number.NEGATIVE_INFINITY,
    ]);
}
export function arrayEquals(arrayA, arrayB) {
    return Array.isArray(arrayA) &&
        Array.isArray(arrayB) &&
        arrayA.length === arrayB.length &&
        arrayA.every((val, index) => val === arrayB[index]);
}
export function formatNumber(value) {
    return Math.round(value).toLocaleString(undefined, { minimumFractionDigits: 0 });
}
export function isEmailValid(emailInput) {
    if (emailInput) {
        // eslint-disable-next-line
        const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
        if (emailRegex.test(emailInput.value)) {
            emailInput.setCustomValidity('');
            emailInput.reportValidity();
            return true;
        }
        emailInput.setCustomValidity('Zadejte prosím platnou e-mailovou adresu.');
        emailInput.reportValidity();
        return false;
    }
    return true;
}
export function populateSelectBox(selectBox) {
    if (!selectBox) {
        return;
    }
    phoneCodes.forEach((item, i) => {
        const option = document.createElement('option');
        if (i === 0) {
            option.selected = true;
        }
        option.value = item.code;
        option.textContent = `${item.name} (${item.code})`;
        option.setAttribute("data-full-label", `${item.code} ${item.name}`);
        selectBox.appendChild(option);
    });
}
export function handlePhoneCodeChange(phoneInput, phoneCodeInput, phoneCodesDropdown) {
    phoneCodeInput.value = phoneCodesDropdown.value;
    const selectedCode = phoneCodesDropdown.value;
    if (selectedCode === "+420" || selectedCode === "+421") {
        phoneInput.pattern = "\\d{9}";
        phoneInput.title = "Telefonní číslo musí obsahovat přesně 9 číslic";
    }
    else {
        phoneInput.pattern = "\\d+";
        phoneInput.title = "Telefonní číslo musí obsahovat pouze číslice";
    }
}
